
export const NO_ACTIVITY_ERROR_MESSAGE = "Oups 🤦‍♀️ Une erreur est survenue. Réessayez plus tard.";
export const OFFLINE_MESSAGE = "Vérifiez votre connexion internet";